import React from "react";
import { ChevronRight } from "../../assets/svgs";
import useApp from "../../hooks/useApp";
import "./styles.scss";

const SettingsCard = ({
  isLastItem,
  cardIcon,
  cardLabel,
  cardSubLabel = "",
  onPress,
}) => {
  const { isRTL } = useApp();
  return (
    <div
      className={`settings-card-container ${isLastItem && "border-bottom-0"}`}
      onClick={onPress}
    >
      <div className="card-btn-content">
        <img
          src={cardIcon}
          alt="card-btn-icon"
          className={isRTL ? "card-btn-icon-rtl" : "card-btn-icon"}
        />
        <div className="card-btn-textwrapper">
          <span className="card-btn-label">{cardLabel}</span>
          <span className="card-btn-sublabel">{cardSubLabel}</span>
        </div>
        <img
          src={ChevronRight}
          alt="setting-card-arrow"
          className={isRTL ? "setting-card-arrow-rtl" : ""}
        />
      </div>
    </div>
  );
};

export default SettingsCard;
